export class PrivateCustomer {
  firstname?: string;
  lastname?: string;
  fullname?: string;
  birthdate?: Date;

  ssn?: string;

  address?: string;
  city?: string;
  postCode?: string;

  phone?: string;
  email?: string;

  identificationType: IdentificationType;
  identificationNumber: string;

  deliveryAddress: DeliveryAddress;
}

export class DeliveryAddress {
  firstName?: string;
  lastName?: string;
  address?: string;
  city?: string;
  postCode?: string;
}

export enum IdentificationType {
  drivinglicence = 'Førerkort',
  passport = 'Pass',
}

export enum BankIdVerificationDeliveryMethod {
  SMS = 'mobilnummeret',
  Email = 'eposten',
}
